(()=>{

  window.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.subpage-indices') === null) return;
    const swiper = new Swiper('.subpage-indices .swiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
    });

    window.addEventListener('load', ()=>{
      swiper.update();
      document.querySelectorAll('.subpage-indices .swiper a').forEach((item,index) => {
        if (item.classList.contains('--active')) {
          console.log(index)
          swiper.slideTo(index);
        }
      })
    })

    const subpageIndices = document.querySelector('.subpage-indices');
    const subPageIndexContent = document.querySelector('.subpage-index-content');


    window.addEventListener('scroll', () => {
      console.log("onScroll")
      const subpageIndicesRect = subpageIndices.getBoundingClientRect();
      if (subpageIndicesRect.top <= 1) {
        subpageIndices.classList.add('--stickied');
        document.querySelector('#header').classList.add('--force-hide');
      } else {
        subpageIndices.classList.remove('--stickied');
        document.querySelector('#header').classList.remove('--force-hide');
      }
    });


    if (subPageIndexContent) {
      subpageIndices.querySelectorAll('a').forEach((a, index) => {
        if (index === 0) a.classList.add('--active');
        a.addEventListener('click', (e) => {
          e.preventDefault();
          const id = a.getAttribute('href').replace('#', '');
          const target = document.getElementById(id);
          if (target) {
            const targetY = target.getBoundingClientRect().top + window.scrollY + 1;
            window.scrollTo({
              top: targetY,
              behavior: 'smooth',
            });
          }
        });
      });
      ScrollTrigger.create({
        trigger: subPageIndexContent,
        start: 'top top',
        end: 'bottom bottom',
        onEnter: () => {
          subpageIndices.classList.add('--stickied');
          swiper.update();
        },
        onLeaveBack: () => {
          subpageIndices.classList.remove('--stickied');
        },
        onUpdate: (self) => {
          const progress = self.progress;
          subpageIndices.style.setProperty('--progress', progress);
        },
      });

      subPageIndexContent.querySelectorAll('.index-content').forEach((element, index) => {
        const id = element.getAttribute('id');
        ScrollTrigger.create({
          trigger: element,
          start: 'top top',
          end: 'bottom top',
          onEnter: () => {
            subpageIndices.querySelectorAll('a').forEach((a) => a.classList.remove('--active'));
            subpageIndices.querySelectorAll('a')[index].classList.add('--active');
            // swiper이동
            swiper.slideTo(index);
          },
          onEnterBack: () => {
            subpageIndices.querySelectorAll('a').forEach((a) => a.classList.remove('--active'));
            subpageIndices.querySelectorAll('a')[index].classList.add('--active');
            // swiper이동
            swiper.slideTo(index);
          },
        });
      })
    }
  })
})();